import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import DragIndicatorIcon from '@material-ui/icons/DragIndicatorSharp';
import { Tooltip } from '@material-ui/core';
import useStyles from './useStyles';

const DragStartIndicator = ({
  classes: classesOverrides,
  gestureBindEvents,
  style,
  showTooltip = false,
  startDate
}) => {
  const classes = useStyles({ classes: classesOverrides });

  return (
    <Tooltip
      title={
        showTooltip && startDate
          ? startDate.toLocaleString({ month: 'short', day: 'numeric' })
          : ''
      }
    >
      <div
        className={classNames(
          classes.resizeHandle,
          classes.resizeHandleStart,
          'dragIndicator'
        )}
        resize="start"
        style={style}
        {...(gestureBindEvents ? gestureBindEvents() : {})}
      >
        <DragIndicatorIcon className={classes.resizeIcon} />
      </div>
    </Tooltip>
  );
};

DragStartIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  gestureBindEvents: PropTypes.func,
  showTooltip: PropTypes.bool,
  startDate: PropTypes.object
};

export default DragStartIndicator;
